// extracted by mini-css-extract-plugin
export default {"learnContainer":"Learn_learnContainer__MfzaV","title":"Learn_title__OCtB+"};